import variables from "./variables";

export const ENV = process.env.REACT_APP_ENVIRONMENT;

export const typeName = "__typename";

export const BASE_URL = variables[ENV]["baseUrl"];
export const SITE_ID = variables[ENV]["siteId"];
export const FORMS_ID = variables[ENV]["formsId"];
export const TOKENS_ID = variables[ENV]["tokensId"];
export const AMANDA_URL = variables[ENV]["amandaUrl"];
export const AMANDA_SERVICE_ACCOUNT = variables[ENV]["amandaServiceAccount"];
export const PAYPAL_CLIENT_ID = variables[ENV]["paypalClientId"];

export const SHIPPING_COST = 5.5;
export const URL_BACK_PREF = "https://www.zara.com/";
export const URL_BACK_SUF = "/preowned-repair-mkt5796.html?v1=2165615";
export const URL_CLOSE_APP = "http://www.zara.com/recom/close";
export const URL_OK = "https://www.zara.com/uk/";
export const URL_OK_FR = "https://www.zara.com/fr/";

export const PAYPAL_MARKETS_ID = {
  fr: "16513",
  gb: "16246",
};

export const MARKETS_ID = {
  de: 10705,
  fr: 10703,
  gb: 10706,
  es: 99999,
};

export const MARKETS_DESCRIPTION = {
  de: "Germany",
  fr: "France",
  gb: "United Kingdom",
  es: "Spain",
};

export const CURRENCY = {
  de: "EUR",
  fr: "EUR",
  gb: "GBP",
  es: "EUR",
};

export const TITLE = "Repair_";

export const PROVINCES = [
  { key: "FR1", value: "AIN" },
  { key: "FR2", value: "AISNE" },
  { key: "FR3", value: "ALLIER" },
  { key: "FR4", value: "ALPES-DE-HAUTE-PROVENCE" },
  { key: "FR6", value: "ALPES-MARITIMES" },
  { key: "FR7", value: "ARDÈCHE" },
  { key: "FR8", value: "ARDENNES" },
  { key: "FR9", value: "ARIÈGE" },
  { key: "FR10", value: "AUBE" },
  { key: "FR11", value: "AUDE" },
  { key: "FR12", value: "AVEYRON" },
  { key: "FR67", value: "BAS-RHIN" },
  { key: "FR13", value: "BOUCHES-DU-RHÔNE" },
  { key: "FR14", value: "CALVADOS" },
  { key: "FR15", value: "CANTAL" },
  { key: "FR16", value: "CHARENTE" },
  { key: "FR17", value: "CHARENTE-MARITIME" },
  { key: "FR18", value: "CHER" },
  { key: "FR19", value: "CORRÈZE" },
  { key: "FR2A", value: "CORSE-DU-SUD" },
  { key: "FR21", value: "CÔTE-D'OR" },
  { key: "FR22", value: "CÔTES-D'ARMOR" },
  { key: "FR23", value: "CREUSE" },
  { key: "FR79", value: "DEUX-SÈVRES" },
  { key: "FR24", value: "DORDOGNE" },
  { key: "FR25", value: "DOUBS" },
  { key: "FR26", value: "DRÔME" },
  { key: "FR91", value: "ESSONNE" },
  { key: "FR27", value: "EURE" },
  { key: "FR28", value: "EURE-ET-LOIR" },
  { key: "FR29", value: "FINISTÈRE" },
  { key: "FR30", value: "GARD" },
  { key: "FR32", value: "GERS" },
  { key: "FR33", value: "GIRONDE" },
  { key: "FR68", value: "HAUT-RHIN" },
  { key: "FR2B", value: "HAUTE-CORSE" },
  { key: "FR31", value: "HAUTE-GARONNE" },
  { key: "FR43", value: "HAUTE-LOIRE" },
  { key: "FR52", value: "HAUTE-MARNE" },
  { key: "FR70", value: "HAUTE-SAÔNE" },
  { key: "FR74", value: "HAUTE-SAVOIE" },
  { key: "FR87", value: "HAUTE-VIENNE" },
  { key: "FR5", value: "HAUTES-ALPES" },
  { key: "FR65", value: "HAUTES-PYRÉNÉES" },
  { key: "FR92", value: "HAUTS-DE-SEINE" },
  { key: "FR34", value: "HÉRAULT" },
  { key: "FR35", value: "ILLE-ET-VILAINE" },
  { key: "FR36", value: "INDRE" },
  { key: "FR37", value: "INDRE-ET-LOIRE" },
  { key: "FR38", value: "ISÈRE" },
  { key: "FR39", value: "JURA" },
  { key: "FR40", value: "LANDES" },
  { key: "FR41", value: "LOIR-ET-CHER" },
  { key: "FR42", value: "LOIRE" },
  { key: "FR44", value: "LOIRE-ATLANTIQUE" },
  { key: "FR45", value: "LOIRET" },
  { key: "FR46", value: "LOT" },
  { key: "FR47", value: "LOT-ET-GARONNE" },
  { key: "FR48", value: "LOZÈRE" },
  { key: "FR49", value: "MAINE-ET-LOIRE" },
  { key: "FR50", value: "MANCHE" },
  { key: "FR51", value: "MARNE" },
  { key: "FR53", value: "MAYENNE" },
  { key: "FR54", value: "MEURTHE-ET-MOSELLE" },
  { key: "FR55", value: "MEUSE" },
  { key: "FR56", value: "MORBIHAN" },
  { key: "FR57", value: "MOSELLE" },
  { key: "FR58", value: "NIÈVRE" },
  { key: "FR59", value: "NORD" },
  { key: "FR60", value: "OISE" },
  { key: "FR61", value: "ORNE" },
  { key: "FR75", value: "PARIS" },
  { key: "FR62", value: "PAS-DE-CALAIS" },
  { key: "FR63", value: "PUY-DE-DÔME" },
  { key: "FR64", value: "PYRÉNÉES-ATLANTIQUES" },
  { key: "FR66", value: "PYRÉNÉES-ORIENTALES" },
  { key: "FR69", value: "RHÔNE" },
  { key: "FR71", value: "SAÔNE-ET-LOIRE" },
  { key: "FR72", value: "SARTHE" },
  { key: "FR73", value: "SAVOIE" },
  { key: "FR77", value: "SEINE-ET-MARNE" },
  { key: "FR76", value: "SEINE-MARITIME" },
  { key: "FR93", value: "SEINE-SAINT-DENIS" },
  { key: "FR80", value: "SOMME" },
  { key: "FR81", value: "TARN" },
  { key: "FR82", value: "TARN-ET-GARONNE" },
  { key: "FR90", value: "TERRITOIRE DE BELFORT" },
  { key: "FR95", value: "VAL-D'OISE" },
  { key: "FR94", value: "VAL-DE-MARNE" },
  { key: "FR83", value: "VAR" },
  { key: "FR84", value: "VAUCLUSE" },
  { key: "FR85", value: "VENDÉE" },
  { key: "FR86", value: "VIENNE" },
  { key: "FR88", value: "VOSGES" },
  { key: "FR89", value: "YONNE" },
  { key: "FR78", value: "YVELINES" },
];
